import * as React from 'react';

import { getCountry, isCountryAllowed } from 'lib/get-geo-country';
import {
  getServerSideProps as getServerSidePropsReal,
  GetServerSidePropsType,
} from 'lib/get-server-side-props';
import { NextApiRequest, NextApiResponse } from 'next';

import { BFFComingSoonContainer } from 'containers/about/bff-coming-soon-container';

const BFFComingSoonPage: React.FunctionComponent = () => {
  return <BFFComingSoonContainer />;
};

export default BFFComingSoonPage;

export const getServerSideProps = async function ({
  query,
  locale,
  res,
  req,
}: GetServerSidePropsType) {
  const country = getCountry(query, req as NextApiRequest, res as NextApiResponse);
  console.log('BFF US country:', country);
  if (country && !isCountryAllowed(country)) {
    return {
      notFound: true,
    };
  }

  const resolvedUrl = req.url || '';

  return getServerSidePropsReal({ query, locale, res, req, resolvedUrl });
};
